import { callDeepLink } from '@croquiscom-pvt/web2app';
import { IconArrowRightBold, NormalButton, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import getConfig from 'next/config';

import { isZigzag } from '@common/device-manager';
import { PopupViewType } from '@domains/pdp-common';

export type AgreementType = 'recommend' | 'compare';

const AGREEMENT_TITLES: Record<AgreementType, React.ReactNode> = {
  recommend: (
    <>
      사이즈 추천을 받으려면
      <br />
      동의가 필요해요
    </>
  ),
  compare: (
    <>
      사이즈를 비교하려면
      <br />
      동의가 필요해요
    </>
  ),
};

interface AgreementBottomSheetProps {
  onClose: () => void;
  onAgree: () => void;
  catalogProductId: string;
  noPadding?: boolean;
  type?: AgreementType;
}

export const AgreementBottomSheet = ({
  onClose,
  onAgree,
  catalogProductId,
  noPadding,
  type = 'recommend',
}: AgreementBottomSheetProps) => {
  const config = getConfig().publicRuntimeConfig.config;

  const handleDetailClick = () => {
    if (isZigzag()) {
      const url = `${config.appUrl}/products/${catalogProductId}/popup?type=${PopupViewType.SIZE_INFO_AGREEMENT_DETAIL}`;
      callDeepLink('/simple_browser')({
        url: encodeURIComponent(url),
        title: '맞춤 정보 수집 및 이용 동의',
      });
    } else {
      window.open(`${config.appUrl}/profile/body/agreement`, '_blank');
    }
  };

  return (
    <Container noPadding={noPadding}>
      <TitleWrapper noPadding={noPadding}>
        <Title variant='Head_20_Bold' color='textPrimary'>
          {AGREEMENT_TITLES[type]}
        </Title>
      </TitleWrapper>
      <DetailButtonWrapper noPadding={noPadding}>
        <DetailButton onClick={handleDetailClick}>
          <Text variant='Body_14_Regular' color='textTertiary'>
            선택정보 맞춤 정보 수집 및 이용 동의
          </Text>
          <IconHolder variant='Body_13_SemiBold' color='textSecondary'>
            보기
            <IconArrowRightBold size={16} color='textSecondary' />
          </IconHolder>
        </DetailButton>
      </DetailButtonWrapper>

      <Buttons noPadding={noPadding}>
        <NormalButton variant='tertiaryGray' size='large' onClick={onClose}>
          나중에
        </NormalButton>
        <NormalButton variant='primary' size='large' onClick={onAgree}>
          동의
        </NormalButton>
      </Buttons>
    </Container>
  );
};

const Container = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ noPadding }) => (noPadding ? '24px 0 20px 0' : '24px 20px 40px 20px')};
  margin: ${({ noPadding }) => (noPadding ? '-16px' : '0')};
  gap: 16px;
`;

const TitleWrapper = styled.div<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => (noPadding ? '0 20px' : '0')};
  text-align: center;
`;

const Title = styled(Text)`
  text-align: center;
`;

const DetailButtonWrapper = styled.div<{ noPadding?: boolean }>`
  display: flex;
  border-radius: 6px;
  background-color: ${vars.color.backgroundOnElevated};
  margin: ${({ noPadding }) => (noPadding ? '0 20px' : '0')};
`;

const DetailButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  cursor: pointer;
  padding: 13px 16px;
`;

const IconHolder = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Buttons = styled.div<{ noPadding?: boolean }>`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  padding: ${({ noPadding }) => (noPadding ? '0 20px' : '0')};

  button {
    flex: 1;
  }
`;
